import { createListenerMiddleware } from "@reduxjs/toolkit";
import { logout } from "../slice/authSlice.js";
import { baseApi } from "../api/baseApi.js";
import { APP_CONFIG } from "../../constants/app.js";
import { updateLastActivity } from "../slice/authSlice.js";

export const authMiddleware = createListenerMiddleware();

// Session timeout handling
authMiddleware.startListening({
  actionCreator: updateLastActivity,
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState();
    const { lastActivity } = state.auth;

    // Check if session has expired
    const now = Date.now();
    const sessionExpired = now - lastActivity > APP_CONFIG.SESSION_TIMEOUT;

    if (sessionExpired && state.auth.isAuthenticated) {
      listenerApi.dispatch(logout());
      // Clear all API cache on logout
      listenerApi.dispatch(baseApi.util.resetApiState());
    }
  },
});

// Auto-logout on token expiry
// authMiddleware.startListening({
//   matcher: baseApi.endpoints.getCurrentUser.matchRejected,
//   effect: async (action, listenerApi) => {
//     if (action.payload?.status === 401) {
//       listenerApi.dispatch(logout());
//       listenerApi.dispatch(baseApi.util.resetApiState());
//     }
//   },
// });
